//Custom Alert Message

export const CustomAlertMessage = (message, type, enqueueSnackbar) => {
  enqueueSnackbar(message, {
    anchorOrigin: {
      vertical: "top",
      horizontal: "center",
    },
    variant: type,
    autoHideDuration: 2000,
  });
};
export const SingleStringFirstLetterCaps = (value) => {
  return value ? value.charAt(0).toUpperCase() + value.slice(1) : "";
};
